<template>
  <InsightsChartsTab :charts="chartConfigurations" :filters="filters" :dateRange="dateRange" :pdfMode="pdfMode" />
</template>

<script>
import { CHART_NAMES, INSIGHTS_CHARTS } from '@/helpers/insightsCharts'

export default {
  name: 'InsightsLiquidatedDamagesView',
  props: {
    filters: {
      type: Array,
      required: true,
      default: () => []
    },
    dateRange: {
      type: Array,
      required: true,
      default: () => []
    },
    pdfMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartConfigurations () {
      const chartTypes = [
        CHART_NAMES.LDS_VALUE_AND_COUNT_CONTRACTOR
      ]

      return chartTypes.map(chartName => ({
        name: chartName,
        componentName: INSIGHTS_CHARTS[chartName].component,
        defaultQuery: INSIGHTS_CHARTS[chartName].defaultQuery,
        defaultTimeDimension: INSIGHTS_CHARTS[chartName].defaultTimeDimension,
        chartWidth: INSIGHTS_CHARTS[chartName].chartWidth
      }))
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'))
    })
  }
}
</script>
